import { Grid } from '@/components/app'
import { Card, CardContent } from '@/components/ui/card'
import { Typography } from '@/components/app'
import { SectionTitle } from './SectionTitle'
import { AppOffer, Cards, JwelleryDesign, OrderTracking, Stack, TrendUp } from '../icons/customIcons'
import { motion } from 'framer-motion'
import { fadeUp, scaleIn, staggerContainer, viewportOnce } from '@/lib/animations'

const features = [
  {
    icon: <Stack/>,
    title: 'Browse Jewellery Collections',
    description: 'Explore curated collections of gold, silver, and diamond jewellery from top brands.',
  },
  {
    icon: <TrendUp/>,
    title: 'Real-time Gold Price Updates',
    description: 'Stay informed with live gold and silver rates to make the best purchasing decisions.',
  },
  {
    icon: <JwelleryDesign/>,
    title: 'Design Your Own Jewellery',
    description: 'Create unique pieces by selecting gemstones, styles, or uploading your own design.',
  },
  {
    icon: <Cards/>,
    title: 'Secure Checkout',
    description: 'Shop with confidence using our encrypted payment gateway and secure transactions.',
  },
  {
    icon: <OrderTracking/>,
    title: 'Order Tracking',
    description: 'Track your precious delivery in real-time from our vault to your doorstep',
  },
  {
    icon: <AppOffer/>,
    title: 'Exclusive App Offers',
    description: 'Unlock special discounts and early access to new collections only on the app.',
  },
]

export function FeaturesSection() {
  return (
    <section id="features" className="py-6 md:py-10 lg:py-12">
      <div className="wrapper">
        {/* Section Title */}
        <motion.div
          className="mb-6 md:mb-10"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <SectionTitle
            badge="KEY FEATURES"
            title="Everything You Need to Shop Smart"
            subtitle="Our app is packed with features designed to give you the best jewellery shopping experience."
            centered
          />
        </motion.div>

        {/* Features Grid */}
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={6} sm={6} md={4} key={index}>
                <motion.div
                  variants={fadeUp}
                  custom={index}
                  className="h-full"
                  whileHover={{ y: -4, transition: { duration: 0.2 } }}
                >
                  <Card className="h-full hover:shadow-lg transition-shadow">
                    <CardContent className="p-5 flex flex-col gap-4">
                      {/* Icon */}
                      <motion.div
                        className="w-12 h-12 rounded-[12px] border border-border-light flex items-center justify-center text-black"
                        whileHover={{ scale: 1.1, rotate: 5, transition: { duration: 0.2 } }}
                      >
                        {feature.icon}
                      </motion.div>

                      {/* Content */}
                      <div className="flex flex-col gap-2">
                        <Typography variant="h6" className="font-semibold">
                          {feature.title}
                        </Typography>
                        <Typography variant="body1" color="muted">
                          {feature.description}
                        </Typography>
                      </div>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </div>
    </section>
  )
}
